var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseContainer',[_c('v-content',{staticClass:"main-container",attrs:{"slot":"principal"},slot:"principal"},[_c('v-container',[_c('PricingSection'),_c('TestimonialsCarousel',{staticClass:"section"}),_c('v-divider',{staticClass:"mt-6"}),_c('Footer',{staticClass:"section"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }